import React from "react";
import { useSelector } from "react-redux";

/**
 * Renders a small banner at the top of the app whenever the user is signed
 * in via demo credentials. Makes it impossible to confuse demo data with
 * real production data on a screen-share or recording.
 */
const DemoBanner = () => {
  // We detect demo mode via the cached authUser flag, but mirror it through
  // Redux (`is_super_admin` is set by the demo profile mock) so the banner
  // re-renders correctly when state hydrates.
  const status = useSelector((s) => s.Profile.status);

  let isDemo = false;
  try {
    const u = JSON.parse(localStorage.getItem("authUser") || "null");
    isDemo = Boolean(u && u.demo);
  } catch (_) {
    isDemo = false;
  }
  if (!isDemo || status === "anonymous") return null;

  return (
    <div
      role="status"
      style={{
        // Static (not sticky) so it scrolls away — the in-content sticky
        // Header below stays at top:0 without competing with this banner.
        position: "relative",
        zIndex: 50,
        background:
          "linear-gradient(90deg, rgba(243,175,76,0.18) 0%, rgba(188,126,255,0.16) 100%)",
        borderBottom: "1px solid rgba(243,175,76,0.45)",
        color: "#ffd199",
        padding: "0.45rem 1rem",
        fontSize: 13,
        textAlign: "center",
        fontFamily: "var(--bl-font-body)",
        letterSpacing: "0.01em",
      }}
    >
      <i className="ri-flask-line" style={{ marginRight: 6 }} />
      <strong style={{ fontWeight: 600 }}>DEMO MODE</strong>
      &nbsp;— read-only with sample data. Nothing here is real, and no requests
      go to the backend.
    </div>
  );
};

export default DemoBanner;
